module.exports = __webpack_public_path__ + "static/media/daebak-realestate.7bd9e52e.md";